/* eslint-disable @typescript-eslint/no-explicit-any */
export interface Code {
  displayName: string;
  value: string;
}

export class Codes {
  constructor(public codes: Code[]) {}

  /** All of the code values */
  get values() {
    return this.codes.map(item => item.value);
  }

  /** All of the code display names */
  get names() {
    return this.codes.map(item => item.displayName);
  }

  /** Get the code object by its display name */
  getByDisplayName(name: string) {
    return name == null ? null : this.codes.find(item => item.displayName === name);
  }

  /** Get the code object by its value (the value of the property) */
  getByValue(value: any) {
    return value == null ? null : this.codes.find(item => item.value === value);
  }

  /** Get the code's display name, given the code value (AKA its "code")*/
  getDisplayName(value: string) {
    const code = this.getByValue(value);
    return code ? code.displayName : '';
  }

  /** Get the code value, given the code's display name */
  getValue(displayName: string) {
    const code = this.getByDisplayName(displayName);
    return code ? code.displayName : '';
  }
}
